import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface AlertFilledSmallProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const AlertFilledSmall = forwardRef<SVGSVGElement, AlertFilledSmallProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.warning20}
          fillRule='evenodd'
          d='M12 22.504c5.799 0 10.5-4.701 10.5-10.5 0-5.8-4.701-10.5-10.5-10.5s-10.5 4.7-10.5 10.5c0 5.799 4.701 10.5 10.5 10.5'
          clipRule='evenodd'
        ></path>
        <path
          fill={secondaryColor ?? '#6B4E11'}
          fillRule='evenodd'
          d='M13.5 7.879a1.5 1.5 0 0 0-3 0v4.27a1.5 1.5 0 1 0 3 0zm-1.5 9.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

AlertFilledSmall.displayName = 'AlertFilledSmall';

export default AlertFilledSmall;
